import { Box, FormControl, InputLabel } from "@mui/material";
import { useId } from "react";
import { useInput } from "react-admin";
import { BufferTimes } from "../model/BufferTimes";
import { NumberInput } from "./NumberInput";

interface BufferTimesInputProps {
  source: string;
  preparationTimeLabel: string;
  wrapUpTimeLabel: string;
  size?: "small";
  disabled?: boolean;
}

export function BufferTimesInput(props: BufferTimesInputProps) {
  const { preparationTimeLabel, wrapUpTimeLabel, size, disabled, ...rest } = props;
  const { field, formState } = useInput<BufferTimes>({
    defaultValue: { preparationTime: 0, wrapUpTime: 0 },
    ...rest,
  });
  const preparationTimeId = useId();
  const wrapUpTimeId = useId();
  const fieldSx = { width: "100%", minWidth: 0 };
  const numberInputSx = {
    width: "100%",
    minWidth: 0,
    "& .MuiInputBase-root": { width: "100%", minWidth: 0, justifyContent: "space-between" },
    "& .MuiOutlinedInput-root": { justifyContent: "space-between" },
    "& .MuiInputBase-input": { minWidth: "100px", width: "4ch" },
    "& .MuiOutlinedInput-input": { minWidth: "100px", width: "4ch" },
  };

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "minmax(0, 1fr) minmax(0, 1fr)" },
        gap: 2,
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",
        alignSelf: "stretch",
      }}
    >
      <Box sx={fieldSx}>
        <FormControl sx={fieldSx}>
          <InputLabel htmlFor={preparationTimeId} size={size}>
            {preparationTimeLabel}
          </InputLabel>
          <NumberInput
            id={preparationTimeId}
            value={field.value.preparationTime}
            onChange={(value) => {
              // eslint-disable-next-line react-compiler/react-compiler
              field.value.preparationTime = value;
              field.onChange(field.value);
            }}
            min={0}
            max={60}
            step={5}
            size={size}
            unit="Min."
            sx={numberInputSx}
            disabled={disabled || formState.isSubmitting}
          />
        </FormControl>
      </Box>
      <Box sx={fieldSx}>
        <FormControl sx={fieldSx}>
          <InputLabel htmlFor={wrapUpTimeId} size={size}>
            {wrapUpTimeLabel}
          </InputLabel>
          <NumberInput
            id={wrapUpTimeId}
            value={field.value.wrapUpTime}
            onChange={(value) => {
              field.value.wrapUpTime = value;
              field.onChange(field.value);
            }}
            min={0}
            max={60}
            step={5}
            size={size}
            unit="Min."
            sx={numberInputSx}
            disabled={disabled || formState.isSubmitting}
          />
        </FormControl>
      </Box>
    </Box>
  );
}
